import {lighten, Theme} from "@mui/material";

const estadoPrestamo = (theme:Theme) => ({

    "&.estado2":{//SALDADO
       background:"rgba(21,164,216,0.30) !important",
        "& .estado":{
            color: "#15a4d8",
        }
    },
    "&.estado3, &.estado4":{//ANULADO
      //  background:"rgba(21,216,193,0.13) !important",
        "& .estado":{
            color: "#d84315",
        }
    },
    "&.estado5":{//REENGANCHADO
        //  background:"rgba(21,216,193,0.13) !important",
        "& .estado":{
            color: "#15d2d8",
        }
    },
    "&.situacion4:not(.estado2)":{//CUOTASVENCIDA
        background:"rgba(216, 67, 21, 0.13) !important",
        "& .estado":{
            color: "#d84315",
        }
    },
    "&.situacion3":{//mora
        background:"rgba(255, 111, 0, 0.05) !important",
        "& .estado":{
            color: "#ff6f00",
        }
    },
    "&.situacion2":{ //pendiente
        background:"rgba(25, 118, 210, 0.07) !important",
        "& .estado":{
            color: "#1976d2",
        }
    },


    //
    // "&.incobrable, &.atrasado":{
    //     background: lighten(theme.palette.error.main, 0.9)+" !important",
    //     "& .estado":{
    //         color: theme.palette.error.main,
    //     }
    // },
    // "&.anulado":{
    //     background: lighten(theme.palette.error.light, 0.9)+" !important",
    //     "& .estado":{
    //         color: theme.palette.error.light,
    //     }
    // },
    // "&.mora":{
    //     background: lighten(theme.palette.warning.main, 0.9)+" !important",
    //     "& .estado":{
    //         color: theme.palette.warning.dark,
    //     }
    // },
    // "&.pendiente":{
    //     background: lighten(theme.palette.info.light, 0.9)+" !important",
    //     "& .estado":{
    //         color: theme.palette.info.dark,
    //     }
    // },
    // "& .content":{
    //     padding:theme.spacing(1),
    //     // [theme.breakpoints.only('xs')]: {
    //     //   overflow: "auto",
    //     // },
    // }
});
export default estadoPrestamo
